import styled from 'styled-components'
import { colors } from 'themes'

export const Wrapper = styled.div<{ isRiskTemplate: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;

  > label {
    font-size: ${({ isRiskTemplate }) => isRiskTemplate ? 16 : 12}px;
    margin-bottom: ${({ isRiskTemplate }) => (isRiskTemplate ? 0 : 6)}px !important;
  }
`

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  min-width: 100%;
`

export const ResultRow = styled.div<{ $even: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 12px;
  font-size: 14px;
  white-space: nowrap;
  width: 100%;
  background-color: ${({ $even }) => ($even ? '#f5f5f5' : '#e2e2e2')};
`

export const RecordLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${colors.blue300};

  &:hover {
    text-decoration: underline;
  }
`

export const ParentRecordLink = styled.span`
  cursor: pointer;
  color: ${colors.blue300};

  &:hover {
    text-decoration: underline;
  }
`

export const Postfix = styled.span`
  color: gray;
`
